// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__BSpie","primary":"Button_primary__3FASX","secondary":"Button_secondary__2BFTA","alt":"Button_alt__RW-zh"};